import Auth from "./auth";
import Account from "./Account";
import Verification from "./verification";
export default { Auth, Account, Verification };
